import React, { useEffect, useState } from "react";

import "./FloatingButtons.css";

const FloatingButtons = () => {
const [whatsappNumber, setWhatsappNumber] = useState(
  localStorage.getItem("whatsappNumber") || ""
);

const [callNumber, setCallNumber] = useState(
  localStorage.getItem("callNumber") || ""
);
  // ✅ LOAD FROM LOCAL STORAGE (NO API CALL HERE)

 useEffect(() => {

  const updateNumbers = () => {

    const wa = localStorage.getItem("whatsappNumber");

    const call = localStorage.getItem("callNumber");

    setWhatsappNumber(wa || "");

    setCallNumber(call || "");

  };

  // ✅ Existing saved number immediately load
  updateNumbers();

  // ✅ Google Sheet se new number aate hi immediately update
  window.addEventListener("contactNumbersUpdated", updateNumbers);

  return () => {
    window.removeEventListener("contactNumbersUpdated", updateNumbers);
  };

}, []);

  const handleCall = () => {

    window.location.href = `tel:${callNumber}`;

  };

  const whatsappMessage = encodeURIComponent(
    "How can I order this product ?"
  );

  // ❌ jab tak number na mile kuch bhi render mat karo

  if (!whatsappNumber || !callNumber) return null;

  return (

    <>

      {/* 📞 CALL FLOATING BUTTON */}

      <button
        className="floating-call"
        onClick={handleCall}
        aria-label="Call Now"
      >

        <i className="fas fa-phone-alt"></i>

      </button>

      {/* 🟢 WHATSAPP FLOATING BUTTON */}

      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp"
        aria-label="Chat on WhatsApp"
      >

        <i className="fab fa-whatsapp"></i>

      </a>

    </>

  );

};

export default FloatingButtons;